import { render, staticRenderFns } from "./ExportSalesByFamily.vue?vue&type=template&id=471df931&"
import script from "./ExportSalesByFamily.vue?vue&type=script&lang=js&"
export * from "./ExportSalesByFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports